var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"action d-flex justify-center",attrs:{"dense":"","type":_vm.type,"height":"max-content","icon":"mdi-information-outline","color":_vm.color,"text":_vm.text}},[_vm._v(" "+_vm._s(_vm.message)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }